// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1i5iu","colCheckbox":"styles_colCheckbox__1pVKN"};